import { makeStyles } from '@mui/styles'

export const useStyles = makeStyles((theme) => ({
  radiosBox: {
    padding: theme.spacing(3),
    border: '1px solid #F2F2F2',
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      marginBottom: '2vh',
    },
    '& .MuiFormControlLabel-label': {
      textAlign: 'left',
      [theme.breakpoints.down('xl')]: {
        fontSize: 'clamp(0.85em, 2em, 0.85em)',
      },
      [theme.breakpoints.down('sm')]: {
        fontSize: 'clamp(0.7em, 2em, 0.85em)',
      },
    },
  },
  readiosTitle: {
    fontWeight: '500',
    color: `${theme.palette.other.dark} !important`,
    marginBottom: '10px',
    textAlign: 'left',
    [theme.breakpoints.down('xl')]: {
      fontSize: 'clamp(0.85em, 2em, 0.85em)',
    },
  },
}))
